export function validateFirebaseConfig(firebaseConfig: any) {
  // Validate required Firebase environment variables
  const requiredFirebaseConfigValues = [
    "apiKey",
    "authDomain",
    "projectId",
    "storageBucket",
    "messagingSenderId",
    "appId",
    "measurementId",
  ] as (keyof typeof firebaseConfig)[];

  const missingEnvVars = requiredFirebaseConfigValues.filter(
    (envVar) => !firebaseConfig[envVar],
  );

  if (missingEnvVars.length > 0) {
    throw new Error(
      `Missing required Firebase environment variables: ${missingEnvVars.join(", ")}`,
    );
  }
}
